import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import Form from '../form/form';

export default function () {
  const about = document.querySelector('.about');

  if (about) {
    const navBtns = [].slice.call(about.querySelectorAll('.about__nav-btn'));
    const sliderWrp = about.querySelector('.about__slider');
    const sliderBtns = [].slice.call(about.querySelectorAll('.sliderButtons__btn'));
    const slides = [].slice.call(about.querySelectorAll('.about__slide'));
    const excursion = about.querySelector('.about__excursion');
    const sliderNav = about.querySelector('.about__slider-nav');
    const navSlider = {
      instance: null,
      options: {
        slidesPerView: 'auto',
        resistance: true,
        resistanceRatio: 0,
        freeMode: true,
      },
      init() {
        if (window.innerWidth >= 768 && this.instance === null) {
          this.instance = new Swiper(sliderNav, this.options);
        } else if (window.innerWidth <= 767 && this.instance !== null) {
          this.instance.destroy(true, true);
          this.instance = null;
        }
      },
    };

    const innerSlider = {
      instance: undefined,
      options: {
        slidesPerView: 1,
        resistance: true,
        resistanceRatio: 0,
        spaceBetween: 10,
        preloadImages: false,
        lazy: {
          loadPrevNext: false,
        },
        pagination: {
          bulletClass: 'about__image-slider-bullet',
          bulletActiveClass: 'about__image-slider-bullet--active',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className}" style="width: ${100 / (this.slides.length - 1)}%"></span>`;
          },
        },
      },
      init(sliderContainer) {
        if (sliderContainer && innerSlider.instance === undefined) {
          innerSlider.options.pagination.el = sliderContainer.querySelector('.about__image-slider-nav');
          innerSlider.instance = new Swiper(sliderContainer, innerSlider.options);
        }
      },
      destroy() {
        if (innerSlider.instance !== undefined) {
          innerSlider.instance.destroy(true, true);
          innerSlider.instance = undefined;
        }
      },
    };

    const slider = {
      instance: undefined,
      options: {
        autoplay: {
          delay: 3000,
        },
        slidesPerView: 1,
        resistance: true,
        resistanceRatio: 0,
        spaceBetween: 40,
        autoHeight: true,
        speed: 600,
        loop: true,
        navigation: {
          prevEl: sliderBtns[0],
          nextEl: sliderBtns[1],
        },
        simulateTouch: false,
        on: {
          slideChange() {
            if (navBtns.length !== 0) {
              navBtns.forEach(btn => btn.classList.remove('about__nav-btn--active'));
              navBtns[this.realIndex].classList.add('about__nav-btn--active');
              if (navSlider.instance !== null) navSlider.instance.slideTo(this.realIndex);

              if (innerSlider.instance !== undefined) {
                innerSlider.instance.destroy(true, true);
                innerSlider.instance = undefined;
                innerSlider.init(this.slides[this.activeIndex].querySelector('.about__image-slider'));
              }
            }
          },
          init() {
            innerSlider.init(slides[this.realIndex].querySelector('.about__image-slider'));
          },
        },
      },
      init() {
        if (window.innerWidth >= 768) {
          if (slider.instance === undefined) {
            slider.instance = new Swiper(sliderWrp, slider.options);
          }
        } else if (window.innerWidth <= 767) {
          if (slider.instance !== undefined) {
            slider.instance.destroy(true, true);
            slider.instance = undefined;
          }
        }
      },
    };

    if (navBtns.length !== 0) {
      navBtns.forEach((btn, index) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();

          if (slider && slider.instance !== undefined) {
            slider.instance.slideToLoop(index, slider.instance.params.speed);
          }
        });
      });
      navSlider.init();
    }

    if (sliderWrp) {
      slider.init();

      window.addEventListener('resize', () => {
        slider.init();
      });
    }

    if (slides.length !== 0) {
      const closeElements = () => {
        slides.forEach((slide) => {
          if (slide.button && slide.button.classList.contains('about__slide-head--active')) {
            slide.hiddenWrp.style.maxHeight = '';
            slide.button.classList.remove('about__slide-head--active');
            slide.hiddenWrp.classList.remove('about__slide-hidden--show');
          }
          if (window.innerWidth <= 767) {
            innerSlider.destroy();
          }
        });
      };

      slides.forEach((slide) => {
        slide.button = slide.querySelector('.about__slide-head');
        slide.hiddenWrp = slide.querySelector('.about__slide-hidden');
        slide.inner = slide.querySelector('.about__slide-wrp');

        if (slide.button && slide.hiddenWrp) {
          slide.button.addEventListener('click', () => {
            if (window.innerWidth <= 767) {
              if (slide.button.classList.contains('about__slide-head--active')) {
                closeElements();
              } else {
                closeElements();
                slide.button.classList.add('about__slide-head--active');
                slide.hiddenWrp.style.maxHeight = `${slide.inner.offsetHeight}px`;
                slide.hiddenWrp.classList.add('about__slide-hidden--show');
                innerSlider.init(slide.querySelector('.about__image-slider'));
              }
            }
          });
        }
      });

      window.addEventListener('resize', () => {
        navSlider.init();

        if (window.innerWidth >= 768) {
          closeElements();
        }
      });
    }

    if (excursion && !excursion.querySelector('.experts-slider')) {
      new Vue({
        el: excursion,
        delimiters: ['${', '}}'],
        props: ['experts'],
        data: {
          info: window.formsData.excursion.experts,
          loopIndex: 0,
          expert: {
            name: '',
            img: '',
            job: '',
          },
        },
        methods: {
          loopForever(array) {
            this.loop = setInterval(() => {
              this.changeExpert(array[this.loopIndex].id);
              this.loopIndex += 1;

              if (this.loopIndex === array.length) this.loopIndex = 0;
            }, 2000);
          },
          stopLoop() {
            if (this.loop) clearInterval(this.loop);
          },
          changeExpert(id, change = true) {
            let expert;
            if (change) {
              expert = this.info.list.find(el => el.id === id);
            } else {
              expert = this.info.list.find(el => el.checked);
            }

            this.expert.name = expert.name;
            this.expert.job = expert.job;
            this.expert.img = `url(${expert.img})`;
          },
        },
        components: {
          aboutForm: Form(window.formsData.excursion.form),
        },
        mounted() {
          if (this.info && !excursion.querySelector('.experts-slider')) {
            this.changeExpert('', false);
            this.loopForever(this.info.list);
          }
        },
      });
    } else if (excursion.querySelector('.experts-slider')) {
      new Vue({
        el: excursion,
        delimiters: ['${', '}}'],
        data: {
          info: window.formsData.excursion.experts,
          mainSlider: null,
          thumbsSlider: null,
          expert: {
            name: '',
          },
        },
        methods: {
          stopLoop() {
          },
          initSlider() {
            this.thumbsSlider = new Swiper(this.thumbsSlider, {
              slidesPerView: 'auto',
              spaceBetween: 12,
              slideToClickedSlide: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              breakpoints: {
                1023: {
                  slidesPerView: 'auto',
                  spaceBetween: 12,
                },
                767: {
                  slidesPerView: 'auto',
                  spaceBetween: 8,
                },
              },
            });

            if ([].slice.call(this.thumbsSlider.pagination.bullets).length <= 1) {
              this.thumbsSlider.pagination.el.classList.add('experts-slider__pagination--hide');
            }

            const thumbs = this.thumbsSlider;

            this.mainSlider = new Swiper(this.mainSlider, {
              slidesPerView: 1,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              thumbs: {
                swiper: thumbs,
              },
              on: {
                init() {
                  if (thumbs !== undefined) {
                    const slidesThumb = [].slice.call(thumbs.slides);
                    slidesThumb.forEach(tmp => tmp.classList.remove('experts-slider__thumb-slide--active'));
                    slidesThumb[0].classList.add('experts-slider__thumb-slide--active');
                    thumbs.slideTo(0);
                    thumbs.activeIndex = 0;
                    thumbs.clickedIndex = 0;
                  }
                },
                slideChange() {
                  if (thumbs !== undefined) {
                    const slidesThumb = [].slice.call(thumbs.slides);
                    slidesThumb.forEach(tmp => tmp.classList.remove('experts-slider__thumb-slide--active'));
                    slidesThumb[this.realIndex].classList.add('experts-slider__thumb-slide--active');
                    thumbs.slideTo(this.realIndex);
                    thumbs.activeIndex = this.realIndex;
                    thumbs.clickedIndex = this.realIndex;
                  }
                },
              },
            });

            this.mainSlider.on('slideChange', () => {
              this.expert.name = this.thumbsSlider.slides[this.thumbsSlider.realIndex].dataset.name;
              this.expert.job = this.thumbsSlider.slides[this.thumbsSlider.realIndex].dataset.job;
            });
          },
        },
        components: {
          aboutForm: Form(window.formsData.excursion.form),
        },
        mounted() {
          this.mainSlider = this.$el.querySelector('.experts-slider__main');
          this.thumbsSlider = this.$el.querySelector('.experts-slider__thumbs');
          this.initSlider();
        },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./blocks/about/about.js